(function() {
	
	//common_functions.js error, all bets are off
	if (typeof window.idd_common !== 'undefined') return;

	var isIE = window.document.documentMode;
	
	// hier geen arrow functie voor, want oudere browsers ondersteunen.
	var isNull = function(a) {
		return a === null;
	};
	
	// Handle js errors
	window.addEventListener('error', function(event) {
		
		// geen lege errors reporten, want daar hebben/kunnen wij toch niks mee.
		// komt misschien van een browser extensions oid.
		if ([event.message, event.source, event.lineno, event.colno].every(isNull)) {
			return false;
		}
		var stack = "";
		if (typeof event.error != 'undefined') stack = event.error.stack;
		
		sendReport(event.message, event.source, event.lineno, event.colno, stack);
		console.error('jsreport window.error reporting: ', event);
		return false; // error niet annuleren
	});
	
	// Handle failed promises
	window.addEventListener('unhandledrejection', function(event) {
		var error = event.reason;
		
		// fileName, lineNumber en columnNumber alleen in FF
		// weet anders niet hoe we die informatie kunnen krijgen uit een rejected promise, hebben iig stacktrace
		sendReport(error.message, error.fileName || null, error.lineNumber || null, error.columnNumber || null, error.stack);
		console.error('jsreport unhandedrejection reporting: ', error);
	});
	
	
	/**
	 * Verstuur error report.
	 *
	 * @param {string}      error  Leesbare versie van foutmelding
	 * @param {string|null} source bestand
	 * @param {number|null} lineno regel
	 * @param {number|null} colno  kolom
	 * @param {string}      stack  stacktrace
	 */
	function sendReport(error, source, lineno, colno, stack) {
				
		if (idd_isidd() || isIE) {
			return;
		}
		
		// Ignore bots
		if (navigator.userAgent.match('/bot|crawler|spider|crawling/i')) {
			return;
		}
		
		var form = {
			url: window.location.href,
			error: error,
			source: source,
			lineno: lineno,
			colno: colno,
			stack: stack,
		};
		
		var xhr = new XMLHttpRequest();
		xhr.open('POST', idd_uriRoot() + 'js-error', true);
		xhr.setRequestHeader('Content-type', 'application/json');
		
		xhr.send(JSON.stringify(form));
	}
	
	
})();

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
